<template>
  <div
    class="offcanvas-lg offcanvas-start side-bar order-2 order-lg-1 col-lg-3 offset-lg-0 p-0"
    tabindex="-1"
    id="offcanvasResponsive"
    ref="offcanvasResponsive"
    aria-labelledby="offcanvasResponsiveLabel"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasResponsiveLabel"></h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        data-bs-target="#offcanvasResponsive"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <div
        v-if="sideBarLeft === 'lectureList'"
        class="border-lg-end"
      >
        <div class="side-bar--overflow lecture-list">
          <div class="my-4 mx-4" v-if="logo">
            <div class="logo text-center">
              <a :href="back" v-if="layoutType === 0">
                <img :src="logo" alt="" class="img-fluid" style="max-height: 120px" />
              </a>
              <router-link v-else :to="{ name: 'course', params: { course: $route.params.course } }">
                <img :src="logo" alt="" class="img-fluid" style="max-height: 120px" />
              </router-link>
            </div>
          </div>
          <div class="my-5 mx-4">
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                :style="`width: ${progress}%`"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ progress }}%
              </div>
            </div>
          </div>

          <div v-for="section in sections" :key="section.id" class="mb-4 mt-4">
            <div class="lecture-list--section px-4 d-flex">
              <div class="h6 fw-bold me-auto">
                {{ section.title }}
              </div>
              <div v-if="section.delay_days" class="d-flex align-items-center me-2">
                <i class="far fa-clock"></i>
              </div>
              <div class="d-flex align-items-center pointer" @click="toggleLectures(section)">
                <i class="fas fa-angle-down" v-if="section.hide_lectures"></i>
                <i class="fas fa-angle-up" v-else></i>
              </div>
            </div>

            <transition tag="div" name="list">
              <div key="container" v-show="!section.hide_lectures">
                <Lecture v-for="lecture in section.lectures" :key="lecture.id" :lecture="lecture"></Lecture>
              </div>
            </transition>
          </div>
          <div class="mb-4 mt-4 pointer" v-if="exam">
            <hr />
            <div class="px-3">
              <div class="h6 fw-bold">
                <router-link
                  class="btn btn-outline-secondary py-2 px-2 w-100 d-flex"
                  active-class="active"
                  :to="{
                    name: 'exam',
                    params: { course: $route.params.course, exam: exam },
                  }"
                >
                  {{ 'Exam' | translate }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { duration } from '~/player/helpers.js'
import Lecture from '~/player/components/Lecture.vue'

export default {
  components: {
    Lecture,
  },
  data() {
    return {
      bsOffcanvas: null,
    }
  },
  mounted() {
    this.setUpOffcanvas()
  },
  computed: {
    layoutType() {
      return _.get(this.course, 'settings.layout', 0)
    },
    exam() {
      return this.course.exam_id
    },
    back() {
      return this.$api.back(this.$route.params.course)
    },
    logo() {
      if (this.course.cover_photo) {
        return `https://djceg34j53tq.cloudfront.net/${this.course.cover_photo}`
      }
      return 'https://placehold.co/1280x800/E1D4F1/ffffff'
    },
    page() {
      return this.$store.state.page
    },
    course() {
      return this.$store.state.course
    },
    sideBarLeft() {
      return this.$store.state.sideBarLeft
    },
    sections() {
      return this.$store.state.course.sections
    },
    progress() {
      return this.$store.getters.lectureProgress
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    hasAccess() {
      return this.$store.state.hasAccess
    },
  },
  methods: {
    setUpOffcanvas() {
      this.bsOffcanvas = new bootstrap.Offcanvas(this.$refs['offcanvasResponsive'])
      this.$router.afterEach((to, from) => {
        this.bsOffcanvas.hide()
      })
    },
    hideOffcanvas() {
      this.bsOffcanvas.hide()
    },
    duration(minutes) {
      return duration(minutes)
    },
    toggleLectures(section) {
      if (section.hide_lectures) {
        section.hide_lectures = !section.hide_lectures
      } else {
        section.hide_lectures = true
      }

      this.$store.commit('updateSection', section)
    },
  },
}
</script>

<style>
@media (min-width: 992px) {
  .border-lg-end {
    border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color);
  }
}
</style>
